// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { PinInput } from '@mantine/core';
import { Stack, Center, Group } from '@/components/ui/layout';
import { Title, Text, Button, Anchor } from '@/components/ui/core';
import { IconArrowLeft, IconDeviceMobile, IconMail, IconShieldCheck } from '@tabler/icons-react';
import { AuthLayoutWrapper } from '../components';

export default function OtpSplit() {
  const [otp, setOtp] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('OTP submitted:', otp);
  };

  const splitContent = (
    <Stack gap="xl" p="xl" style={{ color: 'white' }} align="center" justify="center" h="100%">
      <Center
        style={{
          width: 120,
          height: 120,
          borderRadius: 30,
          backgroundColor: 'rgba(255,255,255,0.15)',
        }}
      >
        <IconDeviceMobile size={60} />
      </Center>

      <Stack align="center" gap="xs">
        <Title order={2} c="white">Check your device</Title>
        <Text style={{ opacity: 0.9 }} ta="center" maw={280}>
          We've sent a verification code to your registered device.
        </Text>
      </Stack>

      <Group gap="md" mt="xl">
        <Group gap="xs">
          <IconShieldCheck size={18} style={{ opacity: 0.8 }} />
          <Text size="sm" style={{ opacity: 0.8 }}>Secure verification</Text>
        </Group>
        <Group gap="xs">
          <IconMail size={18} style={{ opacity: 0.8 }} />
          <Text size="sm" style={{ opacity: 0.8 }}>Email backup</Text>
        </Group>
      </Group>
    </Stack>
  );

  return (
    <AuthLayoutWrapper
      variant="split"
      splitContent={splitContent}
      gradientFrom="#8b5cf6"
      gradientTo="#a855f7"
      backgroundImage="https://images.unsplash.com/photo-1563986768609-322da13575f3?w=1200&auto=format&fit=crop"
    >
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/app/demo/auth-pages/otp"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to variants
        </Button>

        {/* Header */}
        <div>
          <Title order={2}>Enter verification code</Title>
          <Text c="dimmed" size="sm" mt="xs">
            Enter the 6-digit code we sent to your device.
          </Text>
        </div>

        {/* OTP Input */}
        <form onSubmit={handleSubmit}>
          <Stack gap="lg">
            <Center>
              <PinInput
                length={6}
                size="xl"
                value={otp}
                onChange={setOtp}
                type="number"
                oneTimeCode
              />
            </Center>

            <Button type="submit" fullWidth color="violet" disabled={otp.length !== 6}>
              Verify
            </Button>
          </Stack>
        </form>

        {/* Resend options */}
        <Stack gap="xs" align="center">
          <Text size="sm" c="dimmed">
            Didn't receive it?
          </Text>
          <Group gap="md">
            <Anchor component="button" type="button" size="sm">
              Resend code
            </Anchor>
            <Text size="sm" c="dimmed">|</Text>
            <Anchor component="button" type="button" size="sm">
              Try another method
            </Anchor>
          </Group>
        </Stack>

        {/* Back to Login */}
        <Center>
          <Anchor component={Link} to="/app/demo/auth-pages/login/split" size="sm">
            <IconArrowLeft size={14} style={{ marginRight: 4, verticalAlign: 'middle' }} />
            Back to login
          </Anchor>
        </Center>
      </Stack>
    </AuthLayoutWrapper>
  );
}
